<div class="spec">
  @if (game(); as g) {
    <header class="spec__head">
      <p class="spec__kicker">Live · Basketball</p>
      <h1 class="spec__title">{{ session()?.name ?? 'Live game' }}</h1>
      <p class="spec__sub">vs {{ g.opponent }}</p>
    </header>

    <section class="spec__board" aria-live="polite">
      <div class="spec__side">
        <span class="spec__label">Home</span>
        <span class="spec__score">{{ homeScore() }}</span>
      </div>
      <div class="spec__clock">
        <div class="spec__time">{{ clockDisplay() }}</div>
        <div class="spec__period">
          {{ g.quarterCount === 4 ? 'Q' : 'H' }}{{ clock()?.currentQuarter ?? 1 }}
          @if (clock()?.running) {
            · LIVE
          } @else {
            · paused
          }
        </div>
      </div>
      <div class="spec__side">
        <span class="spec__label">{{ g.opponent || 'Away' }}</span>
        <span class="spec__score">{{ awayScore() }}</span>
      </div>
    </section>

    <section class="spec__panel">
      <h2>Recent plays</h2>
      <ul class="spec__plays">
        @for (p of recentPlays(); track trackPlay($index, p)) {
          <li class="spec__play" [class.spec__play--away]="p.team === 'away'">
            <span class="spec__period-tag">{{ g.quarterCount === 4 ? 'Q' : 'H' }}{{ p.quarter }}</span>
            <span class="spec__clock-tag">{{ formatClockSec(p.clockSec) }}</span>
            <span class="spec__player">{{ p.playerName }}</span>
            <span class="spec__action">{{ p.label }}</span>
          </li>
        } @empty {
          <li class="spec__empty">Waiting for first play…</li>
        }
      </ul>
    </section>

    <section class="spec__panel">
      <h2>Box score</h2>
      <table mat-table [dataSource]="boxRows()" [trackBy]="trackBox" class="spec__table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Player</th>
          <td mat-cell *matCellDef="let r">{{ r.name }}</td>
        </ng-container>
        <ng-container matColumnDef="pts">
          <th mat-header-cell *matHeaderCellDef>PTS</th>
          <td mat-cell *matCellDef="let r">{{ r.points }}</td>
        </ng-container>
        <ng-container matColumnDef="fg">
          <th mat-header-cell *matHeaderCellDef>FG</th>
          <td mat-cell *matCellDef="let r">{{ r.fgMade }}/{{ r.fgAtt }}</td>
        </ng-container>
        <ng-container matColumnDef="3p">
          <th mat-header-cell *matHeaderCellDef>3P</th>
          <td mat-cell *matCellDef="let r">{{ r.threePtMade }}/{{ r.threePtAtt }}</td>
        </ng-container>
        <ng-container matColumnDef="ft">
          <th mat-header-cell *matHeaderCellDef>FT</th>
          <td mat-cell *matCellDef="let r">{{ r.ftMade }}/{{ r.ftAtt }}</td>
        </ng-container>
        <ng-container matColumnDef="reb">
          <th mat-header-cell *matHeaderCellDef>REB</th>
          <td mat-cell *matCellDef="let r">{{ r.rebTotal }}</td>
        </ng-container>
        <ng-container matColumnDef="ast">
          <th mat-header-cell *matHeaderCellDef>AST</th>
          <td mat-cell *matCellDef="let r">{{ r.ast }}</td>
        </ng-container>
        <ng-container matColumnDef="stl">
          <th mat-header-cell *matHeaderCellDef>STL</th>
          <td mat-cell *matCellDef="let r">{{ r.stl }}</td>
        </ng-container>
        <ng-container matColumnDef="blk">
          <th mat-header-cell *matHeaderCellDef>BLK</th>
          <td mat-cell *matCellDef="let r">{{ r.blk }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="boxColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: boxColumns"></tr>
      </table>
    </section>
  } @else {
    <p class="spec__empty">This game isn’t broadcasting yet.</p>
  }
</div>
